import { AnimatePresence, motion } from "framer-motion";
import Glossary from "../components/Glossary";
import ProductRow from "../components/ProductRow";
import { apps } from "../data/products";

export default function Investing() {
  const list = apps.investing;

  return (
    <main data-testid="page-investing" style={{ padding: "140px 0 100px" }}>
      <section className="container">
        <span className="eyebrow">Investing</span>
        <h1 style={{ fontSize: "clamp(44px, 6vw, 80px)", marginTop: 22, marginBottom: 18, lineHeight: 0.98 }}>
          The best <em style={{ fontStyle: "italic", color: "var(--emerald)" }}>investing apps</em> for students.
        </h1>
        <p style={{ fontSize: 18, color: "var(--t2)", maxWidth: 660 }}>
          Whether you want to buy your first ETF, start small with fractional shares, or build a beginner-friendly portfolio, these platforms are the strongest picks for students right now.
        </p>

        <Glossary section="investing" />

        <div style={{ position: "relative" }}>
          <AnimatePresence mode="wait" initial={false}>
            <motion.div
              key="investing"
              initial={{ opacity: 0, y: 12, filter: "blur(4px)" }}
              animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              exit={{ opacity: 0, y: -8, filter: "blur(3px)" }}
              transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
              style={{ display: "flex", flexDirection: "column", gap: 16 }}
            >
              {list.map((p, i) => (
                <ProductRow key={p.slug} product={p} index={i} sectionPath="/investing" />
              ))}
            </motion.div>
          </AnimatePresence>
        </div>

        <p style={{ marginTop: 36, textAlign: "center", fontSize: 13.5, color: "var(--t3)" }}>
          Information accurate as of August 31st, 2026.
        </p>
      </section>
    </main>
  );
}
